// src/services/contactService.js
import { API_ENDPOINTS } from '../config/constants';

// Service layer for contact form submissions
// Abstracted for future backend integration

export class ContactService {
  /**
   * Submit contact form data
   * @param {Object} formData - Contact form data
   * @returns {Promise<Object>} Response object
   */
  static async submitContactForm(formData) {
    try {
      const response = await fetch(API_ENDPOINTS.contactForm, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorResponse = await response.json().catch(() => null);
        throw new Error(errorResponse?.message || 'Failed to submit form');
      }

      return await response.json();
    } catch (error) {
      console.error('Error submitting contact form:', error);
      return {
        success: false,
        message: error.message || 'Something went wrong. Please try again or email us directly.',
      };
    }
  }

  /**
   * Subscribe to newsletter
   * @param {string} email - Email address
   * @returns {Promise<Object>} Response object
   */
  static async subscribeNewsletter(email) {
    try {
      console.log('Newsletter Subscription:', email);

      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        success: true,
        message: 'Successfully subscribed to our newsletter!',
      };
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      return {
        success: false,
        message: 'Failed to subscribe. Please try again.',
      };
    }
  }
}
